import { useEffect, useState } from "react";

import {
  areOnboardingImagesReady,
  ensureOnboardingImagesPreloaded,
} from "./onboardingImagePreload";

/** Waits until all active-flow onboarding illustrations are fetched and decoded. */
export function useOnboardingImagesReady(): boolean {
  const [ready, setReady] = useState(areOnboardingImagesReady);

  useEffect(() => {
    if (ready) return;

    let cancelled = false;

    void ensureOnboardingImagesPreloaded().then(() => {
      if (!cancelled) {
        setReady(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [ready]);

  return ready;
}

/** @deprecated Prefer `useOnboardingImagesReady` when gating UI; kept for fire-and-forget preload. */
export function useOnboardingImagePreload(): void {
  useEffect(() => {
    void ensureOnboardingImagesPreloaded();
  }, []);
}
